export default __webpack_public_path__ + "static/media/store-12.0c23810d.png";